export interface IClosedLoopCreateLinks {
    dash: boolean,
    donor: boolean,
    donorShieldDirect: boolean,
    watr: boolean,
    followUpDonor: boolean
}